import { connect } from "react-redux";
import {formValueSelector, getFormSyncErrors, getFormValues } from "redux-form";
import { bindActionCreators } from "redux";
import Form from "../../components/forms/Statement/StatementForm";
import {
  newStatement,
  //createStatement,
  sendStatement,
  withRedirect,
  getMe,
  getStatementPdf,
  getOfficial,
} from "../../CroActions";
import { isOfficial } from "../../CroUtils";
import { breadcrumbs } from "../../../../actions/appActions";
import { getDecodedUser } from "../../../../utils/login";
import { noop } from "lodash";
import { idObj } from "../../../../utils";

const getInitialValues = () => ({
  official: { id: getDecodedUser().sub },
  workingPositions: [{}],
});

const selector = formValueSelector("statementForm");
const allData = getFormValues("statementForm");

const mapStateToProps = (state, { params }) => ({
  breadcrumbsItems: [{ label: "Oznámení" }, { label: "Nové oznámení" }],

  naturalPersonBusinessesEnabled: selector(
    state,
    "naturalPersonBusinessesEnabled",
  ), // || null,
  legalBusinessAssociatesEnabled: selector(
    state,
    "legalBusinessAssociatesEnabled",
  ), // || null,
  organizationMemberEnabled: selector(state, "organizationMemberEnabled"), // || null,
  mediaEnabled: selector(state, "mediaEnabled"), // || null,
  otherContractsEnabled: selector(state, "otherContractsEnabled"), // || null,
  realtiesEnabled: selector(state, "realtiesEnabled"), // || null,
  realtiesBeforeEnabled: selector(state, "realtiesBeforeEnabled"), // || null,
  commercialPapersEnabled: selector(state, "commercialPapersEnabled"), // || null,
  commercialPapersBeforeEnabled: selector(
    state,
    "commercialPapersBeforeEnabled",
  ), // || null,
  corporationSharesEnabled: selector(state, "corporationSharesEnabled"), // || null,
  corporationSharesBeforeEnabled: selector(
    state,
    "corporationSharesBeforeEnabled",
  ), // || null,
  chattelsEnabled: selector(state, "chattelsEnabled"), // || null,
  chattelsBeforeEnabled: selector(state, "chattelsBeforeEnabled"), // || null,
  incomesEnabled: selector(state, "incomesEnabled"), // || null,
  liabilitiesEnabled: selector(state, "liabilitiesEnabled"), // || null,

  realties: selector(state, "realties") || null,
  realtiesBefore: selector(state, "realtiesBefore") || null,
  commercialPapers: selector(state, "commercialPapers") || null,
  commercialPapersBefore: selector(state, "commercialPapersBefore") || null,
  corporationShares: selector(state, "corporationShares") || null,
  corporationSharesBefore: selector(state, "corporationSharesBefore") || null,
  chattels: selector(state, "chattels") || null,
  chattelsBefore: selector(state, "chattelsBefore") || null,

  toDate: selector(state, "toDate") || null,
  fromDate: selector(state, "fromDate") || null,

  //workingPositions: selector(state, 'workingPositions') || [],
  workingPositions: selector(state, "officialWorkingPositions") || [],

  deputy: selector(state, "official.deputy") || false,
  deputyAndOthers: selector(state, "official.deputyAndOthers") || false,
  senator: selector(state, "official.senator") || false,
  senatorAndOthers: selector(state, "official.senatorAndOthers") || false,
  dos:
    selector(state, "official.deputy") ||
    selector(state, "official.senator") ||
    false,
  dosStatement: selector(state, "senator") || false,
  promiseDocumented: selector(state, "official.promiseDocumented") || false,
  type_senator: selector(state, "type_senator"),
  hasPoint3: selector(state, "official.hasPoint3") || false,

  officialId: selector(state, "official.id"),
  getAllData: () => allData(state),
  statementOfficial: selector(state, "statementOfficial") || null,

  fileStatement: selector(state, "fileStatement") || null,
  fileStatementPrivate: selector(state, "fileStatementPrivate") || null,
  hasFileRef: selector(state, "hasFileRef"),

  type: selector(state, "type"),
  state: selector(state, "state") || null,
  initialValues: getInitialValues(),
  getMe,
  getOfficial,
  workingPositionsAll: selector(state, "official.workingPositions"),
  isNew: true,
  files: selector(state, "files") || [],
  invalidFields: getFormSyncErrors('statementForm')(state),
});

// const onSubmit = (startUrl, params) =>
//   withRedirect(
//     startUrl.includes("funkcionar")
//       ? createStatement(startUrl)
//       : newStatement(startUrl),
//     startUrl.includes("funkcionar")
//       ? "/funkcionar/oznameni"
//       : `/administrator/funkcionari/form/${params.id}`,
//   );

const onSubmit = (startUrl, params) =>
    withRedirect(
        newStatement(startUrl),
        startUrl.includes("funkcionar")
            ? "/funkcionar/oznameni"
            : `/administrator/funkcionari/form/${params.id}`,
    );

const onSend = (startUrl) =>
  withRedirect(
    (data) => async (dispatch) => {
      const idData = idObj(data);
      await newStatement(startUrl)(idData, null)(dispatch);
      await sendStatement(idData)(dispatch);
    },
    "/funkcionar/oznameni",
  );

const mapDispatchToProps = (dispatch, { params, auth = {} }) => ({
  ...bindActionCreators(
    {
      breadcrumbs,
      exportPdf: getStatementPdf(auth.startUrl),
      exportPdfRequest: getStatementPdf(auth.startUrl, "request"),
    },
    dispatch,
  ),
  onSubmit: (data) => dispatch(onSubmit(auth.startUrl, params)(data)),
  onSend: (data) =>
    isOfficial(auth) ? dispatch(onSend(auth.startUrl)(data)) : noop,
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
